var lib_core           = require("lib-core");

var MasterModel        = require("./masterModel.js");
var MasterView         = require("./masterView.js");
var MasterStateMachine = require("./masterStateMachine.js");

var MasterController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        SWITCH_TAB: {id: 'mstrlt_0', name: "SWITCH_TAB", isGuiButton: true },
        CANVAS_RESIZE: {id: 'mstrlt_1', name: "CANVAS_RESIZE"}
    });
};
lib_core.inherit(MasterController, lib_core.Controller);
MasterController.inject = {};

MasterController.prototype.createStateMachine = function () {
    return new MasterStateMachine(this.root, this.getModel());
};

MasterController.prototype.createView = function () {
    if (this.root.data.metaData && this.root.data.metaData())
        this.configuration.title = this.root.data.metaData().name;
    return new MasterView(this.getModel(), this.getStatemachine(), this.editorHolder, this.configuration);
};

MasterController.prototype.createModel = function () {
    return new MasterModel(this.root, this.configuration);
};

MasterController.prototype.beforeLoad = function() {
    this.editorHolder = this.root.editorHolder;
    lib_core.Controller.prototype.beforeLoad.call(this);
};

MasterController.prototype.afterLoad = function () {
    var first_tab = this.getModel().tabs.get(0);

    if (first_tab) {
        this.autoAppendArgs = ["idle", null, "idle", null, first_tab.name()];
    }

    lib_core.Controller.prototype.afterLoad.call(this);

};

MasterController.prototype.afterBuild = function () {
    var first_tab = this.getModel().tabs.get(0);

    if (first_tab) {
        this.getModel().activeTab(first_tab.name());
    }
};

MasterController.prototype.addTab = function (tab, button, theme) {
    var self = this;

    var tab_name = tab.name();
    this.getModel().tabs.push(tab);

    // SET THEME
    if(theme) tab.getView().setTheme(theme);

    // BUTTON EVENT HANDLER
    var name = 'test';
    var title = '#test';
    var icon = 'icon-view-electronicslab.svg';
    var border = (this.getModel().tabs.size() === 1) ? "left" : false;

    if(button) {
        if(button.name) name = button.name;
        if(button.title) title = button.title;
        if(button.style) {
            if(button.style.icon) icon = button.style.icon;
        }
    };

    if(this.configuration.noNav) return;
    
    var tab_button = this.getView().cio_ui_topnav.addTabButton(name, title, icon, undefined, undefined, border);

    tab_button.$el.on('Cioui:MenuTabButon:clicked', function(e){
        var cEvent = new lib_core.GuiEvent();
        cEvent.type(lib_core.GuiEvents.SWITCH_TAB);
        cEvent.data("tab", tab.name());
        self.getStatemachine().handle(cEvent);
    });

    self.model.activeTab.onChange("activeTabOnChange"+tab_name, function(value, old) {
        if(value == tab_name)
            tab_button.setActive();
        else
            tab_button.setInactive();
    });

    this.getStatemachine().addTab(tab, tab_button);

    return tab_button;
};

module.exports = MasterController;
